import React from 'react';
import { GetStaticProps } from 'next';

import styles from './styles.module.scss';

import { withLayoutAndSession } from '@utils/hocs';
import { PageWithProvidersAndLayout } from '@utils/types/nextApp';
import WysiwygText from '@components/_shared/wysiwygText';
import { getTermsOfServiceContent } from '@api/termsOfService/getTermsOfServiceContent';
import { getSeoMetadata, TSeoFields } from '@api/global/getSeoMetadata';
import MetaHead from '@components/_shared/metaHead';

type Props = {
  content: any;
  seoMetadata: TSeoFields;
};

const TermsOfService: PageWithProvidersAndLayout<Props> = (props: Props) => {
  const { content, seoMetadata } = props;

  return (
    <>
      <MetaHead {...seoMetadata} />

      <main className={styles.termsOfService}>
        <WysiwygText
          content={content}
          containerStyle={styles.termsOfService__content}
        />
      </main>
    </>
  );
};

export const getStaticProps: GetStaticProps<any> = async () => {
  try {
    const data = await getTermsOfServiceContent();
    const seoMetadata = await getSeoMetadata();
    return {
      props: {
        content: data.content,
        seoMetadata: {
          title: seoMetadata?.termsOfService?.title || 'Terms of Service',
          description: seoMetadata?.termsOfService?.description || '',
          ogImage: seoMetadata?.termsOfService?.ogImage || '',
        },
      },
      revalidate: 30,
    };
  } catch (error) {
    return {
      notFound: true,
      revalidate: 10,
    };
  }
};

export default withLayoutAndSession(TermsOfService, {
  headerProps: { theme: 'white' },
  footerProps: { theme: 'white' },
});
